import React, { useEffect, useState } from 'react';
import BookingSlider from '../Slider/BookingSlider';
import Loader from '../Loader/Loader';
import { useUser } from '@clerk/nextjs';
import type { BookingType } from '@/types/booking';
import { useTranslate } from '@tolgee/react';
import { useBookingService } from '@/hooks/useBookingService';

const EventSlider: React.FC = () => {
  const [events, setEvents] = useState<BookingType[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, _setError] = useState<Error | null>(null);
  const { user } = useUser();
  const { t } = useTranslate();
  const { getUserBookings } = useBookingService();

  useEffect(() => {
    const fetchBookings = async () => {
      try {
        if (!user?.id) return;
        const bookings = await getUserBookings(user.id, false, 5);

        setEvents(bookings);
        setLoading(false);
      } catch (_error) {
        console.error('Error fetching events');
        setLoading(false);
      }
    };

    void fetchBookings();
  }, [user]);

  if (loading)
    return (
      <div className="relative h-28">
        <Loader position={'absolute'} />
      </div>
    );
  if (error) return <div>Error loading data</div>;
  if (events.length === 0) return null;
  return (
    <div>
      <BookingSlider
        items={events}
        title={t('bookings_section.title.label')}
        seeAllLink="/bookings"
      />
    </div>
  );
};

export default EventSlider;
